import type { IconProps } from "../types";

export const MemoryStick = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 12v-2" />
    <path d="M12 18v-2" />
    <path d="M16 12v-2" />
    <path d="M16 18v-2" />
    <path d="M2 11h1.5" />
    <path d="M20 18v-2" />
    <path d="M20.5 11H22" />
    <path d="M4 18v-2" />
    <path d="M8 12v-2" />
    <path d="M8 18v-2" />
    <rect x="2" y="6" width="20" height="10" />
  </svg>
);
